'use client';
import Image from 'next/image';
import AchievementsListV2 from './AcievementsCardsV2/AchievementsListV2';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';
import { ReactNode } from 'react';

export interface AchievementsBlockCustomProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  headerIcon?: string | { url: string; alt: string };
  achievementsList: Array<{
    titleIcon?: string | { url: string; alt: string };
    title: ReactNode | SerializedEditorState;
    subtitle?: ReactNode | SerializedEditorState;
    hover: ReactNode | SerializedEditorState;
    width?: number;
    height?: number;
  }>;
}
export default function AchievementsBlockCustomV5({
  title,
  achievementsList,
  subtitle,
  headerIcon,
  id,
}: AchievementsBlockCustomProps) {
  return (
    <div id={id} data-meta="AchievementsBlockCustomV5">
      <div className="container max-w-7xl mx-auto py-6 sm:py-4">
        <div className="flex justify-center lg:justify-between items-center">
          <CustomRichText
            data={title}
            tag="div"
            className="max-lg:text-center text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8 text-balance"
          />
          {headerIcon && (
            <Image
              width={400}
              height={100}
              alt={typeof headerIcon === 'string' ? '' : headerIcon.alt}
              src={typeof headerIcon === 'string' ? headerIcon : headerIcon.url}
              className="hidden lg:block self-center"
            />
          )}
        </div>
        {subtitle && (
          <CustomRichText
            data={subtitle}
            tag="div"
            className="mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white px-4 text-center"
          />
        )}
      </div>
      <AchievementsListV2 achievementsList={achievementsList} />
    </div>
  );
}
